import AuthService from './services/auth.js';

export function showNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.className = `fixed top-4 right-4 p-4 rounded-md text-white ${
        type === 'error' ? 'bg-red-500' : 'bg-green-500'
    } shadow-lg z-50 transition-opacity duration-500`;
    notification.textContent = message;

    document.body.appendChild(notification);

    setTimeout(() => {
        notification.style.opacity = '0';
    }, 3000);

    setTimeout(() => {
        document.body.removeChild(notification);
    }, 3500);
}

export function showModal(content) {
    // Get the existing modal container from the DOM
    const modalEl = document.getElementById('modal');
    if (!modalEl) return;

    // Set the content inside the modal-content container
    const modalContentEl = modalEl.querySelector('#modal-content');
    modalContentEl.innerHTML = content;

    // Attach the close event to the close button (if not already attached)
    const closeButton = modalEl.querySelector('#modal-close');
    closeButton.onclick = hideModal;

    // Also, close the modal when clicking on the overlay (outside the modal content)
    modalEl.onclick = (e) => {
        if (e.target === modalEl) {
            hideModal();
        }
    };

    // Finally, display the modal (by removing the "hidden" class)
    modalEl.classList.remove('hidden');
}

export function hideModal() {
    const modalEl = document.getElementById('modal');
    if (modalEl) {
        modalEl.classList.add('hidden');
    }
}


export async function authenticatedFetch(url, options = {}) {
    const token = AuthService.getToken();
    if (token) {
        options.headers = {
            ...options.headers,
            'Authorization': `Bearer ${token}`
        };
    }

    try {
        const response = await fetch(url, {
            ...options,
            credentials: 'same-origin'
        });
        
        if (response.status === 401) {
            AuthService.logout();
            window.app.showAuth();
            showNotification('Сессия истекла. Пожалуйста, войдите снова.', 'error');
            throw new Error('Session expired');
        }
        
        return response;
    } catch (error) {
        if (error.message !== 'Session expired') {
            showNotification('Произошла ошибка сети', 'error');
        }
        throw error;
    }
}